import { combineReducers } from 'redux';
import modalReducer from './modalSlice'; // Ensure this is the new slice reducer

const rootReducer = combineReducers({
  modal: modalReducer,
  // Add other reducers here
});

export default rootReducer;
